import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { filter, take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../services/data';

/**
 * Permite /dashboard/tutoriales si:
 * - Settings/features.habilitarTutoriales (toda la misión), o
 * - la iglesia actual tiene tutorialesHabilitados.
 */
export const tutorialsGuard: CanActivateFn = async () => {
  const dataService = inject(DataService);
  const firestore = inject(Firestore);
  const router = inject(Router);

  const church = await firstValueFrom(
    dataService.dataChurch$.pipe(
      filter((c) => !!c && dataService.isDataChurch === true),
      take(1)
    )
  );

  if (church?.tutorialesHabilitados === true) {
    return true;
  }

  try {
    const snap = await getDoc(doc(firestore, 'Settings/features'));
    const raw = snap.exists() ? (snap.data() as { data?: { habilitarTutoriales?: boolean } })?.data : null;
    if (raw?.habilitarTutoriales === true) {
      return true;
    }
  } catch {
    // fallback: denegar
  }

  return router.createUrlTree(['/dashboard/main']);
};
